<ng-container *ngIf="transactions$ | async as transactions">
  <ng-container *ngIf="transactions$ | async as transactions">
    <div *ngFor="let day of transactions | keyvalue : keepOrder">
      <h5 class="transaction-date mt-4 mb-1 text-white text-uppercase">{{ day.key }}</h5>
      <div class="mb-0 mb-lg-5">
        <div class="card my-2 py-2 px-4 bg-primary border-secondary text-white" *ngFor="let transaction of day.value">
          <div class="row font-praktika-bold">
            <div class="col-8 text-start">
              <div class="text-white transaction-text">
                {{ transaction.TransactionDescription }}
              </div>

              <div class="transaction-subtext">
                {{ transaction.TransactionDateUTC | UtcToLocaltimePipe : 'hh:mm a' | uppercase }}
              </div>
            </div>
            <div class="col-4 text-end pt-2">
              <div class="fw-bold transaction-text text-capitalize text-white">
                {{ transaction.Amount >= 0 ? '+' : ''
                }}{{ transaction.Amount | FortressCurrencyPipe : (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!transactions || !hasTransactions">
      <div class="w-100 text-center no-items pt-4">
        <div
          class="no-results-placeholder-description font-size-14 text-white h-100 d-flex flex-column align-items-center justify-content-center"
        >
          <img
            class="svg svg-info vs-svg ms-auto me-auto"
            fgbAnimateSvg
            [src]="'placeholders/no-activity.svg' | contentAssetImage"
          />
          {{ 'transactions.page.placeholder' | translate }}
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<div *ngIf="loading" class="mt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
